import nvSorterColumnModule from '../../sorter-column/nv.sorterColumn.module';

angular.module('nv.components.sorter-col-input', [nvSorterColumnModule]);
